import types from 'constants/actionTypes';

import { combineReducers } from 'redux';
 
const initialState = {

  byId: {},

  indexIds: [],

};
 
const byId = (state = initialState.byId, action) => {

  const { type, payload } = action;
 
  switch (type) {

    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_SUCCESS:

      return {

        ...state,

        ...(payload?.entities?.series || {})

      };

    default:

      return state;

  }

};
 
const indexIds = (state = initialState.indexIds, action) => {

  const { type, payload } = action;
 
  switch (type) {

    case types.GET_DEALERSHIP_ALLOCATION_REQUEST_SUCCESS:

      return payload?.result?.series || [];

    default:

      return state;

  }

};
 
export default combineReducers({

  byId,

  indexIds,

});

 
